import { render, staticRenderFns } from "./PH11V.vue?vue&type=template&id=85cba152&scoped=true"
import script from "./PH11V.vue?vue&type=script&lang=js"
export * from "./PH11V.vue?vue&type=script&lang=js"
import style0 from "./PH11V.vue?vue&type=style&index=0&id=85cba152&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cba152",
  null
  
)

export default component.exports